// store/emailMailing.js
import { defineStore } from 'pinia'
import axios from "@/plugins/axios";

export const useEmailMailingStore = defineStore('emailMailing', {
    state: () => ({
        items: [],
        item: null,
        projectEmailsData: null, // Добавим поле для хранения данных проекта
        loading: false,
        pagination: {
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 0
        }
    }),

    actions: {
        async getList(page = 1, limit = 10) {
            this.loading = true
            try {
                const response = await axios.get('email-mailing', {
                    params: { page, limit }
                })
                this.items = response.data.data
                this.pagination = response.data.pagination
                return response.data
            } catch (error) {
                console.error('Ошибка при загрузке email:', error)
                throw error
            } finally {
                this.loading = false
            }
        },

        // Получить email по ID проекта
        async getEmailsByProjectId(projectId) {
            this.loading = true
            try {
                const response = await axios.get(`email-mailing/project/${projectId}`)
                this.projectEmailsData = response.data
                return response.data
            } catch (error) {
                console.error('Ошибка при загрузке email проекта:', error)
                throw error
            } finally {
                this.loading = false
            }
        },

        // НОВЫЙ МЕТОД: Очистить данные текущего проекта
        clearProjectEmails() {
            this.projectEmailsData = null
        },

        async getById(id) {
            this.loading = true
            try {
                const response = await axios.get(`email-mailing/${id}`)
                this.item = response.data
                return response.data
            } catch (error) {
                console.error('Ошибка при загрузке email:', error)
                throw error
            } finally {
                this.loading = false
            }
        },

        async create(emailData) {
            this.loading = true
            try {
                const response = await axios.post('email-mailing', emailData)
                await this.getList()
                return response.data
            } catch (error) {
                console.error('Ошибка при создании email:', error)
                throw error
            } finally {
                this.loading = false
            }
        },

        async delete(id) {
            this.loading = true
            try {
                await axios.delete(`/api/email-mailing/${id}`)
                await this.getList()
                return true
            } catch (error) {
                console.error('Ошибка при удалении email:', error)
                throw error
            } finally {
                this.loading = false
            }
        },

        async addProjectsToEmail(emailId, projectIds) {
            this.loading = true
            try {
                const response = await axios.post(`email-mailing/${emailId}/projects`, {
                    projectIds
                })
                return response.data
            } catch (error) {
                console.error('Ошибка при добавлении проектов:', error)
                throw error
            } finally {
                this.loading = false
            }
        },

        async removeProjectsFromEmail(emailId, projectIds) {
            this.loading = true
            try {
                const response = await axios.delete(`email-mailing/${emailId}/projects`, {
                    data: { projectIds }
                })
                return response.data
            } catch (error) {
                console.error('Ошибка при удалении проектов:', error)
                throw error
            } finally {
                this.loading = false
            }
        }
    },

    getters: {
        // Получить массив email для текущего проекта
        currentProjectEmails: (state) => {
            return state.projectEmailsData?.emails || []
        },
        // Получить ID проекта
        currentProjectId: (state) => {
            return state.projectEmailsData?.projectId || null
        }
    }
})